module.exports = __webpack_public_path__ + "static/media/zz-ball-bearing.e1ecfe97.png";